import { getNestedBoolean, useConfig } from '@/utils/useConfig';
import GoogleAuth from './GoogleAuth';

/**
 * This component renders social sign-in buttons for Google, Facebook, Twitter, and GitHub.
 * The buttons are conditionally rendered based on the configuration settings.
 * @returns 
 */
function SignInSocialButtons({ disabled }: Readonly<{
    /** Disables the buttons */
    disabled?: boolean;
}>) {

    const { config, loading: _loading, error: _error, refresh: _refresh, isStale: _isStale } = useConfig('auth_pages_config');

    if (getNestedBoolean(config, 'auth.google') === false) {
        return null;
    }

    return <>
        <div className="mt-32 flex items-center">
            <div className="mt-px flex-auto border-t" />
            <p className="mx-8 text-gray-700 italic">
                Or continue with
            </p>
            <div className="mt-px flex-auto border-t" />
        </div>

        <div className="mt-32 flex items-center space-x-16">
            {getNestedBoolean(config, 'auth.google') && (
                <GoogleAuth disabled={disabled} />
            )}
        </div>
    </>;
}

export default SignInSocialButtons;